import styled from 'styled-components';
import { theme } from "../../theme";
import { textStyles } from "../Text";
export var Shortcut = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['compressed'].includes(prop) && defaultValidatorFn(prop);
  }
}).withConfig({
  displayName: "Shortcut",
  componentId: "vapor__vppxaa-0"
})(["height:", ";text-align:center;padding:0 ", ";background:", ";border-radius:", ";box-shadow:0 2px 3px rgba(0,0,0,0.07),inset 0 0.5px 0 rgba(255,255,255,0.2);color:", ";", ";line-height:", ";min-width:", ";", ""], theme.spaces[24], theme.spaces[8], theme.colors.palette.whiteA15, theme.radii[4], theme.colors.palette.whiteA80, textStyles.secondary, theme.spaces[24], theme.spaces[24], function (p) {
  return p.compressed && "\n    height: 20px;\n    line-height: 20px;\n    min-width: 20px;\n    padding: 0 ".concat(theme.spaces[8], ";\n  ");
});